import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

import { RouteObject } from 'react-router-dom'
import Analytics from './components/Analytics'
import BusinessPerformance from './components/BusinessPerformance'
import BusinessTargets from './components/BusinessTargets'
import Incomes from './components/EmployeeIncome'
import Revenue from './components/Revenue'
import SalePerformances from './components/SalePerformances'
import ServiceMonthlyReport from './components/ServiceMonthlyReport'
import TargetAnalytics from './components/TargetAnalytics'

const ReportModule: RouteObject = {
    path: 'reports',
    children: [
        {
            path: 'customers',
            element: <SalePerformances />,
        },
        {
            path: 'services',
            element: <ServiceMonthlyReport />,
        },
        {
            path: 'analytics',
            element: <Analytics />,
        },
        {
            path: 'incomes',
            element: <Incomes />,
        },
        {
            path: 'business-targets',
            element: <BusinessTargets />,
        },
        {
            path: 'targets-analytics',
            element: <TargetAnalytics />,
        },
        {
            path: 'revenues',
            element: <Revenue />,
        },
        {
            path: 'financials',
            element: <BusinessPerformance />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default ReportModule
